import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

import type { SelectOption } from "../types";

interface SelectCellProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[]; // Options to display in { value, label } format
  isEdited: boolean;
  formatter?: (value: unknown) => string;
  placeholder?: string;
  disabled?: boolean;
}

/**
 * Select dropdown cell editor for EditableTable
 * Provides visual feedback for edited state
 */
export function SelectCell({
  value,
  onChange,
  options,
  isEdited,
  formatter,
  placeholder = "-",
  disabled = false,
}: SelectCellProps) {
  const displayValue = formatter ? formatter(value) : value;

  return (
    <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        className={cn(
          "w-full h-10 rounded-sm transition-all hover:bg-accent",
          isEdited ? "border-[3px] border-blue" : "border border-border-input",
        )}
      >
        <SelectValue>{displayValue || placeholder}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
